module.exports = __webpack_public_path__ + "img/img-issue-bg.8385e282.png";